import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';

/**
 * Hook que monitora erros 401 (Unauthorized) e gerencia redirecionamentos automáticos
 * Nota: A interceptação principal agora é feita via Axios interceptor em apiService.ts
 * Este hook fornece funções utilitárias para gerenciar redirecionamentos
 */
export const useTokenInterceptor = () => {
  const { logout } = useAuthStore();

  useEffect(() => {
    // O interceptador principal agora está no Axios (apiService.ts)
    // Este hook serve principalmente para fornecer funções utilitárias
    console.log('🔐 Token interceptor initialized (Axios-based)');
  }, []); // Remove logout dependency to prevent re-initialization

  /**
   * Função para verificar se há uma URL de redirecionamento pendente
   */
  const checkRedirectUrl = (): string | null => {
    return localStorage.getItem('redirect_after_login');
  };

  /**
   * Função para limpar URL de redirecionamento
   */
  const clearRedirectUrl = (): void => {
    localStorage.removeItem('redirect_after_login');
  };

  /**
   * Função para definir URL de redirecionamento manualmente
   */
  const setRedirectUrl = (url: string): void => {
    localStorage.setItem('redirect_after_login', url);
  };

  return {
    checkRedirectUrl,
    clearRedirectUrl,
    setRedirectUrl
  };
};